// extracted by mini-css-extract-plugin
export default {"select":"styles_select__uzldW","error":"styles_error__PI4Lh"};